import React from "react";
import { Link } from "react-router-dom";
import logo from "../../Images/Logo.webp";
import Button from "../Button/Button";
import BackArrow from "../../Images/backArrow.png";

import { useNavigate } from "react-router-dom";

import "./TopBarSingleProject.css"

const TopBarSingleProject = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1); // Equivalent to history.goBack()
  };
  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-6">
            <Link to="/">
              <img src={logo} alt="" className="img_style" />
            </Link>
          </div>
          <div className="col-6">
            <div className="navbar text-right">
              <button onClick={handleGoBack}  className="mt-4 back_button">
                <img  className="img-fluid backbutton" src={BackArrow} alt="" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TopBarSingleProject;
